import { render, staticRenderFns } from "./CareGrid.vue?vue&type=template&id=042c7c19&scoped=true&lang=pug"
import script from "./CareGrid.vue?vue&type=script&lang=js"
export * from "./CareGrid.vue?vue&type=script&lang=js"
import style0 from "./CareGrid.vue?vue&type=style&index=0&id=042c7c19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c7c19",
  null
  
)

export default component.exports